import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

const i18n = createI18n({
  legacy: false, // Composition API mode
  locale: localStorage.getItem('locale') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  missingWarn: false, // 关闭缺失 key 的警告（动态菜单名不在 i18n 文件中）
  fallbackWarn: false, // 关闭回退警告
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

/**
 * Switch locale globally
 * @param {'zh-CN' | 'en-US'} locale
 */
export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
  document.documentElement.setAttribute('lang', locale === 'zh-CN' ? 'zh' : 'en')
}

/**
 * Get current locale
 * @returns {'zh-CN' | 'en-US'}
 */
export function getLocale() {
  return i18n.global.locale.value
}

export default i18n
